const resolveCompanyRecord = (company) => {
  if (!company) return null;
  return company.company || company;
};

const getCompanyDnaCacheKey = (company) => {
  const resolved = resolveCompanyRecord(company);
  const companyId = resolved?.id || resolved?._id || null;
  return companyId ? `loopino_company_dna_${companyId}` : null;
};

const hasTruthySummaryFlag = (summary) => {
  if (!summary) return false;
  const value = summary.has_dna;
  if (value === true) return true;
  if (value === 1) return true;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
  }
  return false;
};

const hasMeaningfulCandidate = (candidate) => {
  if (!candidate) return false;
  if (typeof candidate === 'string') return candidate.trim().length > 0;
  if (Array.isArray(candidate)) return candidate.length > 0;
  if (typeof candidate === 'object') {
    if (typeof candidate.dna === 'string' && candidate.dna.trim()) return true;
    if (typeof candidate.generated_dna === 'string' && candidate.generated_dna.trim()) return true;
    if (typeof candidate.mission === 'string' && candidate.mission.trim()) return true;
    if (typeof candidate.summary === 'string' && candidate.summary.trim()) return true;
    return Object.keys(candidate).length > 0;
  }
  return false;
};

export const getGeneratedDnaValue = (company) => {
  const resolved = resolveCompanyRecord(company);
  if (!resolved) return '';
  const raw = resolved.generated_dna;
  if (!raw) return '';
  if (typeof raw === 'string') return raw.trim();
  if (typeof raw === 'object') {
    const nested = raw.dna || raw.generated_dna;
    return typeof nested === 'string' ? nested.trim() : '';
  }
  return '';
};

export const hasCompanyDna = (company) => {
  const resolved = resolveCompanyRecord(company);
  if (!resolved) return false;

  const cacheKey = getCompanyDnaCacheKey(resolved);
  if (cacheKey && typeof window !== 'undefined') {
    const cached = window.localStorage.getItem(cacheKey);
    if (cached === '1') return true;
  }

  if (hasTruthySummaryFlag(resolved.summary)) {
    if (cacheKey && typeof window !== 'undefined') {
      window.localStorage.setItem(cacheKey, '1');
    }
    return true;
  }

  const candidates = [
    resolved.generated_dna,
    resolved.dna,
    resolved.ai_analysis?.company_identity,
    resolved.ai_analysis?.business_profile,
    resolved.ai_analysis?.communication_style
  ];

  for (const candidate of candidates) {
    if (hasMeaningfulCandidate(candidate)) {
      if (cacheKey && typeof window !== 'undefined') {
        window.localStorage.setItem(cacheKey, '1');
      }
      return true;
    }
  }

  return false;
};

export const hasGeneratedDna = (company) => hasCompanyDna(company);
